import React, { useEffect, useMemo, useState } from 'react'
import dayjs from 'dayjs';
import { Input, Table, DatePicker, Button, Spin, Empty, Modal, Typography, InputNumber } from 'antd';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddIcon from '@mui/icons-material/Add';
import './Inventories.css';
import { Logger } from "../../middleware/Logger"
import ExistingCountModal from '../../Modal/ExistingCountModal';
import { mainAxios } from '../../middleware/interceptor';
import CreateInventoryModal from '../../Modal/CreateInventoryModal';
import { toast } from "react-toastify";
import { SyncOutlined, CheckOutlined, LoadingOutlined } from '@ant-design/icons';

function Inventories({
  setInventoriesDetails,
  CountSheetId,
  CountSheetName,
  InventoryId,
  InventoryDate,
  inventoryDetails,
  restId,
  reRenderData
}) {

  const [existingCountModal, setExistingCountModal] = useState(false);
  const [CountSheetData, setCountSheetData] = useState([]);
  const [createInventoryModal, setCreateInventoryModal] = useState(false);
  const [inventoryDate, setInventoryDate] = useState();
  const [inventoriesTotalValue, setInventoriesTotalValue] = useState(0);
  const [ProductData, setProductData] = useState([]);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [updateInventoryReq, setUpdateInventoryReq] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [autoSave, setAutoSave] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const RestID = localStorage.getItem('RestId');

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const NumberFormatter = new Intl.NumberFormat("en-US", {
    currency: "USD",
    maximumFractionDigits: 2,
  });

  const columns = (data, catId) => [
    {
      title: '',
      dataIndex: '',
      key: '',
      width: 40,
      align: 'center',
      render: () => (
        <RestaurantIcon color='#b10303' fontSize='12' />
      ),
    },
    {
      title: `Product : ${data?.Product}`,
      dataIndex: 'SubProduct',
      key: 'SubProduct',
      width: 350,
    },
    {
      title: 'Recent Purchased',
      dataIndex: 'LastPurchaseDate',
      key: 'LastPurchaseDate',
      width: 200,
      render: (cell) => (
        <>
          {dayjs(cell).format('MM/DD/YYYY')}
        </>
      )
    },
    {
      title: 'Count By',
      dataIndex: 'subProductUnit',
      width: 200,
      key: 'subProductUnit',
    },
    {
      title: 'Price',
      dataIndex: 'subProductPrice',
      key: 'subProductPrice',
      // align: 'left',
      width: 100,
      onHeaderCell: () => ({
        className: 'left-align-header',
      }),
      onCell: () => ({
        className: 'center-align-body',
      }),
      render: (cell) => (
        <>
          {currencyFormatter.format(cell)}
        </>
      )
    },
    {
      title: 'Count',
      dataIndex: 'Count',
      width: 150,
      key: 'Count',
      render: (cell, row) => {
        let total = NumberFormatter.format(cell);

        return (
          <>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div>
                <AddIcon style={{ color: '#19a73f', cursor: 'pointer' }} onClick={() => { setProductData({ ...row, catId: catId }); setExistingCountModal(true); }} />
              </div>
              <div>
                {/* <Input type='number' value={cell} onBlur={() => { updateInventoryCount(updateInventoryReq) }} onChange={(value) => { changeProductCount(catId, row, value.target.value, value.target.value) }} /> */}
                <InputNumber
                  value={total}
                  min={0} max={100000}
                  onChange={(value) => { changeProductCount(catId, row, value, value) }}
                  onBlur={() => { updateInventoryCount(updateInventoryReq) }}
                />
              </div>
            </div>
          </>
        )
      }
    },
    {
      title: 'Value',
      dataIndex: 'Amount',
      key: 'Amount',
      width: 150,
      onHeaderCell: () => ({
        className: 'center-align-header',
      }),
      onCell: () => ({
        className: 'right-align-body',
      }),
      render: (cell) => (
        <>
          {currencyFormatter.format(cell)}
        </>
      )
    },
  ];


  const items = [
    {
      key: "1",
      label: 'Save & Exit',
      onClick: () => setInventoriesDetails(1)
    },
    {
      key: "2",
      label: 'Save & Close',
      onClick: () => setShowCloseModal(true)
    },
  ];

  const CreateNewCountSheet = () => {
    // const isOpen = backupData.filter((item) => item.status === "Open").length;
    // if (isOpen === 0) {
    //     setload(true);
    const osVersionMatch = navigator.userAgent.match(
      /(Windows NT|iPhone|iPad|Android)[^\d]*([\d._]+)/
    );


    let DeviceInfo = {
      DeviceDetails: {
        app_ver: navigator.appVersion,
        api_url: mainAxios.defaults.baseURL,
        device_id: "From Web",
        device_os: navigator.platform,
        os_version: osVersionMatch && osVersionMatch[2] ? osVersionMatch[2] : null,
      },
      CountSheetId: CountSheetId,
      CountSheetName: CountSheetName
    };

    mainAxios
      .post(
        "/api/Inventory/CreateInventory/" + dayjs(inventoryDate).format('YYYY-MM-DD') + "/" + RestID,
        DeviceInfo,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res.data.status == 1) {
          let Details = {
            InventoryDate: dayjs(inventoryDate).format('YYYY-MM-DD'),
            Payload: DeviceInfo
          }
          reRenderData(res.data.inventoryid);
          setCreateInventoryModal(false);
          Logger(RestID, "Countsheet Created", Details, res.data.inventoryid)
          // setTimeout(() => {
          // setload(false);
          // navigate("/inventories/" + Inventory_date);
          // }, [1500]);
        } else {
          setCreateInventoryModal(false);
          toast.warning(res.data.message)
          // setload(false);
          // setIsModalOpenOne(true);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        console.log(err);
        // setload(false);
      });
    // } else {
    // showModal();
    // }
  };

  const calculateAmount = (price, countBy) => {
    if (parseFloat(countBy) === 0) {
      return parseFloat(price) / 1;
    } else {
      return parseFloat(price) / parseFloat(countBy);
    }
  };

  const GetInventoryDetails = async (id) => {
    setIsLoading(true);
    let req = {
      "RestId": parseInt(RestID),
      "Inventorykey": id,
      "page_status": 3
    }
    await mainAxios.post(`api/inventory`, req).then((res) => {
      if (res?.data?.Status === "1") {
        let temp = res?.data?.Data?.InventoryDetails?.map((a) => ({
          ...a,
          GroupedItems: a.GroupedItems.map((b) => ({
            ...b,
            productList: b.productList.map((c) => ({
              ...c,
              subproductlist: c.subproductlist.map((d) => ({
                ...d,
                subProductUnit: !!d.itemsList[0].BaseUnit ? d.itemsList[0].BaseUnit : d.itemsList[0].Unit,
                id: d.itemsList[0].id,
                Inventory_date: d.itemsList[0].Inventory_date,
                location: d.itemsList[0].location,
                Name: d.itemsList[0].Name,
                subProductPrice:
                  !!d.itemsList[0].BaseUnit
                    ? d.itemsList[0].Price
                    : (calculateAmount(d.itemsList[0].Price ?? 0, d.itemsList[0].UnitCountby ?? 1)),
                Purveyor: d.itemsList[0].Purveyor,
                Unit: d.itemsList[0].Unit,
                CountSplit: d.itemsList[0].CountSplit,
                BaseUnit: d.itemsList[0].BaseUnit,
                SubCategoryId: d.itemsList[0].SubCategoryId,
                SubCatName: d.itemsList[0].SubCatName,
                Product: d.itemsList[0].Product,
                ProductId: d.itemsList[0].ProductId,
                Count: d.itemsList[0].Count || '',
                Amount: d.itemsList[0].Amount || ''
              })),
            })),
          })),
        }));
        setCountSheetData(temp);
        calculateProductAmount(temp);
        // Remove extra array wrapping
      } else {
        setCountSheetData([]); // Set empty array if response is invalid
      }
    }).catch((err) => {
      console.log(err)
    });

    setIsLoading(false);
  };

  const changeProductCount = (catId, row, value, countSplit) => {
    let req = {
      "RestId": RestID,
      "catId": catId?.CatId,
      "catName": catId?.CatName,
      "subProductId": row?.subProductId,
      "itemAmount": (value * row?.subProductPrice),
      "itemCount": value,
      "sortkey": InventoryId,
      "countSplit": countSplit
    };
    setUpdateInventoryReq(req);

    let temp = CountSheetData;
    let UpdatedList = temp?.map((a) => (
      a.CatId === catId?.CatId ? {
        ...a,
        GroupedItems: a.GroupedItems.map((b) => (
          b.SubCategoryId === row?.SubCategoryId ?
            {
              ...b,
              productList: b.productList.map((c) => (
                c.ProductId === row?.ProductId ? {
                  ...c,
                  subproductlist: c.subproductlist.map((d) => (
                    d.subProductId === row?.subProductId ? {
                      ...d,
                      Count: value,
                      Amount: (value * d.subProductPrice),
                      CountSplit: countSplit
                    } : d
                  )),
                } : c
              )),
            } : b
        )),
      } : a
    ));
    setCountSheetData(UpdatedList);
    calculateProductAmount(UpdatedList);
  };

  const calculateProductAmount = (inventoriesData) => {
    let tempTotal = 0;
    inventoriesData.map((a) => (
      a.GroupedItems.map((b) => (
        b.productList.map((c) => (
          c.subproductlist.map((d) => (
            d.Amount && (tempTotal = tempTotal + parseFloat(d.Amount))
          ))
        ))
      ))
    ));
    setInventoriesTotalValue(tempTotal)
  };

  const updateInventoryCount = async (req) => {
    if (req.catId) {
      setAutoSave(true);
      await mainAxios.post(`api/Inventory/updateItem`, req).then((res) => {
        if (res.data.status == "1") {
          setAutoSave(false);
        } else {
          toast.warning('Failed to add count');
        }
      }).catch((err) => {
        console.log(err);
        setAutoSave(false);
      })
    }
  }

  const handleCloseInventory = async () => {
    const payload = {
      RestId: restId,
      Date: inventoryDetails?.InventoryId,
    };

    await mainAxios.post(`api/Inventory/status`, payload).then((res) => {
      if (res.data.status === '1') {
        toast.success('Inventory closed successfully');
        setShowCloseModal(false);
        setInventoriesDetails(1);
      } else {
        toast.error('Failed to close the inventory');
        setShowCloseModal(false);
      }
    }).catch((err) => {
      console.error(err);
      toast.error('Failed to close the inventory');
      setShowCloseModal(false);
    })
  };

  const DeleteInventory = () => {
    let req =
    {
      "RestId": restId,
      "Date": inventoryDetails?.InventoryId,
      "Status": 2
    };

    mainAxios.post(`api/Inventory/changeStatusofInventory`, req).then((res) => {
      if (res.data.status === 1) {
        setOpenDeleteModal(false)
        setInventoriesDetails(1);
      }
    }).catch((err) => {
      console.log(err)
    })
  }


  useEffect(() => {
    if (InventoryDate != '') {
      setInventoryDate(dayjs(InventoryDate));
    }
    if (InventoryId) {
      GetInventoryDetails(InventoryId);
    } else {
      setIsLoading(false);
    }
  }, [InventoryId]);

  return (
    <>
      <div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'start', marginBottom: '10px' }}>
          <Button
            // style={{ padding: 0, border: 'none', boxShadow: 'none', marginBottom: '4px' }}
            className='backButton'
            onClick={() => setInventoriesDetails(1)}
            title='Back'
          >
            <ChevronLeftIcon />
          </Button>
          <h5>Enter a "{CountSheetName}" Count</h5>
        </div>
        <div className='noteOuter'>
          <p className='note'>
            "The data will be saved automatically upon entering the count."
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label>Inventory Date :</label>
            <div>
              <DatePicker
                placeholder='Inventory Date'
                onChange={(date, dateString) => {
                  setInventoryDate(date);
                  //
                }}
                disabled={!!InventoryId}
                value={inventoryDate}
                maxDate={dayjs()}
              />
            </div>
            {/* <Search className='custom-search'
              placeholder="Search"
              allowClear
              style={{ width: 200, }}
            /> */}
          </div>
          {!InventoryId && <div style={{ display: 'flex', gap: '10px' }}>
            <Button type='primary' className='Deactivate-Button'
              onClick={() => setInventoriesDetails(1)}>Cancel</Button>
            <Button
              className='printButton2'
              onClick={() => { setCreateInventoryModal(true) }}
              disabled={!inventoryDate}
            >
              Save
            </Button>
          </div>}

          {InventoryId &&
            <div style={{ display: 'flex', gap: '10px' }}>
              {/* <Button disabled icon={}> */}
              {/* <div className='autoSaveButton'>
                {autoSave ? (
                  <>
                    <span style={{ marginBottom: '2px' }}>Saving</span>
                    <SyncOutlined spin />
                  </>
                )
                  :
                  (
                    <>
                      <span style={{ marginBottom: '2px' }}>Saved</span>
                      <CheckOutlined />
                    </>
                  )
                }
              </div> */}
              {/* </Button> */}

              <Button
                className='Deactivate-Button'
                onClick={() => setShowCloseModal(true)}
              >
                Close Inventory
              </Button>
              {/* <Dropdown
                menu={{ items }}
                trigger={['click']}
              >
                <Button className='printDropdown' >
                  <Space>
                    Save Options
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown> */}
              <Button
                type='primary'
                color='danger'
                onClick={() => {
                  setOpenDeleteModal(true)
                }}
                variant='solid'
              >
                Delete Inventory
              </Button>
            </div>
          }
        </div>
        <hr />
        <div style={{ marginTop: '0' }} className='productsContainer'>
          {isLoading && (
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 48,
                      color: '#19a73f'
                    }}
                    spin
                  />
                }
              />
            </div>
          )}
          {!isLoading && !!InventoryId && CountSheetData.length === 0 && (
            <div
              className=''
              style={{
                height: '60vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Empty
                image="/no-item.png"
                styles={{
                  image: {
                    height: 60,
                  },
                }}
                description={
                  <Typography.Text>
                    Please Add Product
                  </Typography.Text>
                }
              >
                {/* <Button
                  className='printButton'
                  icon={<AddIcon />}
                  onClick={() => {
                    setProductModal(true);
                    setIsEditCountSheetName(false);
                    setInventoryName(CountSheetData?.CountSheetName);

                  }}
                  disabled={!isGrouped}
                >
                  <Space>
                    Add Product
                    <RestaurantIcon fontSize='16' />
                  </Space>
                </Button> */}
              </Empty>
            </div>
          )}
          {!isLoading && CountSheetData.length > 0 && CountSheetData?.map((Cat, catIndex) => (
            <div key={catIndex}>
              {Cat?.GroupedItems.length > 0 && (
                <h3 style={{ fontWeight: 500, fontSize: '20px' }}>{Cat?.CatName}</h3>
              )}
              {Cat?.GroupedItems.map((GroupItem, groupIndex) => (
                <div key={groupIndex} className='productsTableContainer'>
                  <div className='productsTable' style={{ marginBottom: '10px' }}>
                    <div className='subCategoryInput'>
                      <div className='head-box'>
                        <span>SubCategory : {GroupItem?.SubCatName}</span>
                      </div>
                      {GroupItem?.productList?.map((Product, productIndex) => (
                        <div key={productIndex} className='Food_table'>
                          <Table
                            dataSource={Product?.subproductlist}
                            columns={columns(Product, Cat)}
                            pagination={false}
                            size={'small'}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        {InventoryId &&
          <>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <div style={{ backgroundColor: '#19a73f', color: '#fff', border: '1px solid #19a73f', padding: '3px', borderRadius: '3px', fontWeight: '500' }}>
                Total Value : ${inventoriesTotalValue === 0 ? '0.00' : inventoriesTotalValue.toFixed(2)}
              </div>
            </div>
          </>
        }
      </div>
      <CreateInventoryModal
        visible={createInventoryModal}
        setVisible={setCreateInventoryModal}
        countSheetDetails={CountSheetName}
        cancel={setInventoryDate}
        confirm={CreateNewCountSheet}
      />
      <ExistingCountModal
        visible={existingCountModal}
        setVisible={setExistingCountModal}
        productData={ProductData}
        reqPayload={updateInventoryReq}
        updateInventory={updateInventoryCount}
        TotalCount={changeProductCount}
      />

      <Modal
        title='Delete Inventory'
        open={openDeleteModal}
        onCancel={() => setOpenDeleteModal(false)}
        closable
        width={400}
        footer={[
          <Button
            className='Deactivate-Button'
            onClick={() => setOpenDeleteModal(false)}
          >
            Cancel
          </Button>,
          <Button
            onClick={() => { DeleteInventory() }}
            className='printButton2'
          >
            Confirm
          </Button>
        ]}
      >
        <div>Are you sure want to delete this Inventory?</div>
      </Modal>

      <Modal
        title='Close Inventory'
        open={showCloseModal}
        onCancel={() => setShowCloseModal(false)}
        closable
        width={400}
        footer={[
          <Button
            className='Deactivate-Button'
            onClick={() => setShowCloseModal(false)}
          >
            Cancel
          </Button>,
          <Button
            onClick={() => { handleCloseInventory() }}
          >
            Confirm
          </Button>
        ]}
      >
        <div>Are you sure want to close the inventory?</div>
      </Modal>
    </>
  )
}

export default Inventories
